import { Injectable } from '@angular/core';
import { LangagesService } from '../langages/langages.service';

@Injectable({
  providedIn: 'root'
})
export class ResponseService {

  constructor(
    private langServ: LangagesService
  ) { }

  getErrorMessage(code: number, params?: any[]): string {

    let errorMessage = ""
    const lang = this.langServ.getLang();
    if(lang){

      const json = require('src/assets/response-api/error/' + lang + '.json');

      errorMessage = json[code.toString()];

      if (params) {
        errorMessage = this.replaceParams(errorMessage, params);
      }
    }

    return errorMessage;
  }

  getSuccessMessage(target: string, params?: any[]): string {
    const lang = this.langServ.getLang();
    const json = require('src/assets/response-api/success/' + lang + '.json');
    let successMessage = json[target.toString()];

    if (params) {
      successMessage = this.replaceParams(successMessage, params);
    }

    return successMessage;
  }

  replaceParams(message: string, params: any[]) {
    params.map(param => {
      const parsedName = "%" + param.name + "%";
      message = message.replace(parsedName, param.value);
    });
    return message;
  }


}
